import React from 'react';
import {useBoolean} from 'src/hooks/useBoolean';
import tableStyles from 'src/components/SimpleTable/body.module.scss';
import Icon from 'shared/components/icon';
import LoadingIcon from 'shared/components/loading';
import classnames from 'classnames';
import styles from './styles.module.scss';
import {ColumnSettings, PersistedItemValue} from './types';

const Display = (props: {
  setEditing: () => void;
  destroy: (id: string) => void;
  columns: ColumnSettings[];
  values: PersistedItemValue;
  disableDeleting?: boolean;
}): React.ReactElement => {
  const deleting = useBoolean(false);

  return (
    <tr
      className={classnames(tableStyles.tr, styles.tr)}
      onClick={props.setEditing}
      data-testid="editable-table-row"
    >
      {props.columns.map((column, i) => {
        const lastItem = i === props.columns.length - 1;

        return (
          <td
            className={classnames(tableStyles.td, 'text-center', styles.td)}
            key={`${column.name}-${props.values.id}`}
            style={column.width ? {width: column.width} : {}}
          >
            {column.renderValue?.(props.values[column.name], props.values)}
            {lastItem &&
              !props.disableDeleting &&
              (deleting.value ? (
                <LoadingIcon className={styles.rightIcon} />
              ) : (
                <button
                  type="button"
                  disabled={deleting.value}
                  onClick={async (e): Promise<void> => {
                    e.stopPropagation();
                    deleting.setTrue();
                    try {
                      await props.destroy(props.values.id);
                    } finally {
                      deleting.setFalse();
                    }
                  }}
                  className={classnames(styles.deleteButton, styles.rightIcon)}
                  data-testid="editable-table-delete-button"
                >
                  <Icon iconType="trash" />
                </button>
              ))}
          </td>
        );
      })}
    </tr>
  );
};

export default Display;
